import { defaultResetDurationInSeconds } from '../../../../../constants/limitations'

export const defaultDuration = defaultResetDurationInSeconds
export const defaultCurrentTime = 0
export const timeLineMinValue = 0
export const timeLineStep = 0.1
